import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div {{did-insert this.handleInsert}}></div>",{ moduleName: "codecrafters-frontend/components/loading-indicator-remover.hbs" })